import APIClient, { NotFoundError } from '../lib/APIClient';
import TicketType from '../records/TicketType';
import { resolve } from '../helpers/LinkMapper';

const dataUrl = '/data/ticket-types';
const cache = {};

const TicketTypeService = {

    get (code) {
        if (cache[code]) {
            return cache[code];
        }

        cache[code] = APIClient.get(dataUrl + '/' + code)
            .then((response) => {
                if (response.result) {
                    return resolve({ ...response.result, id: dataUrl + '/' + code}).as(TicketType);
                }
                return new TicketType();
            })
            .catch((error) => {
                if (error instanceof NotFoundError) { return new TicketType(); }
                delete cache[code];
                throw error;
            });

        return cache[code];
    }
};

export default TicketTypeService;
